export const ConfSurveysActionTypes = {
  API_RESPONSE_SUCCESS: '@@confSurvey/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@confSurvey/API_RESPONSE_ERROR',

  GET_CONF_SURVEY: '@@confSurvey/GET_CONF_SURVEY',
  UPDATE_CONF_SURVEY: '@@confSurvey/UPDATE_CONF_SURVEY',

  RESET: '@@confSurvey/RESET'
}
